import { ZERO } from '../../../../core/constant/number.constant';

export class JavaClass {
  className: string;
  fields: string[];
  methods: string[];
  classModifier: string[];

  constructor(className: string = '', fields: string[] = [], methods: string[] = [], classModifier: string[] = []) {
    this.className = className;
    this.fields = fields;
    this.methods = methods;
    this.classModifier = classModifier;
  }

  isEmpty(): boolean {
    return this.className.length === ZERO && this.fields.length === ZERO && this.methods.length === ZERO;
  }
}
